const axios = require("axios");
const config = require("../../config/app");
const resource = `${config.remote.uri}/admin-3gvhs`;

module.exports = {
  /**
   * Admin 3gvhs list()
   */
  list: function(id = null) {
    if (id == null) {
      return axios.get(resource).then(response => {
        console.log("data from vpn admin3gvg", response);
        return response;
      });
    } else {
      return axios.get(resource + "/" + id).then(response => {
        return response;
      });
    }
  }
};
